export default "__VITE_ASSET__DIetvQfW__"